import * as React from 'react';
import { Edit, SimpleForm, TextInput, useRecordContext, required } from 'react-admin';
import { EditToolbar } from '../../common/EditToolbar';

const LiveCannelEdit = () => {
    return (
        <Edit resource="live_channels" title={<LiveCannelTitle />}>
            <SimpleForm toolbar={<EditToolbar />}>
                <TextInput source="name" validate={[required()]} fullWidth />
                <TextInput source="stream_key" validate={[required()]} fullWidth disabled={true} />
                <TextInput
                    source="playback_key"
                    validate={[required()]}
                    fullWidth
                    disabled={true}
                />
            </SimpleForm>
        </Edit>
    );
};

const LiveCannelTitle = () => {
    const record = useRecordContext();

    return record ? <span>{record.name}</span> : null;
};

export default LiveCannelEdit;
